import { render, staticRenderFns } from "./MarketAnswerEventModal.vue?vue&type=template&id=322aa807&scoped=true&"
import script from "./MarketAnswerEventModal.vue?vue&type=script&lang=js&"
export * from "./MarketAnswerEventModal.vue?vue&type=script&lang=js&"
import style0 from "./MarketAnswerEventModal.vue?vue&type=style&index=0&id=322aa807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322aa807",
  null
  
)

export default component.exports